export default __webpack_public_path__ + "static/media/services-banner.e327f6cf.jpg";